var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfocircle1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_228_18302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6437 39.9805C30.3901 39.9805 39.2875 30.9065 39.2875 19.9902C39.2875 9.05441 30.3708 0 19.6245 0C8.89745 0 0 9.05441 0 19.9902C0 30.9065 8.9167 39.9805 19.6437 39.9805ZM19.6437 36.6487C10.5537 36.6487 3.29321 29.2406 3.29321 19.9902C3.29321 10.7399 10.5344 3.33171 19.6245 3.33171C28.7144 3.33171 36.0134 10.7399 36.0134 19.9902C36.0134 29.2406 28.7337 36.6487 19.6437 36.6487Z",
    fill: "white",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2734 30.9655H24.1117C24.9014 30.9655 25.5176 30.3775 25.5176 29.574C25.5176 28.8097 24.9014 28.2021 24.1117 28.2021H21.7236V18.2266C21.7236 17.1683 21.2037 16.4628 20.2214 16.4628H16.6008C15.8112 16.4628 15.195 17.0703 15.195 17.8346C15.195 18.6382 15.8112 19.2261 16.6008 19.2261H18.6615V28.2021H16.2734C15.4838 28.2021 14.8676 28.8097 14.8676 29.574C14.8676 30.3775 15.4838 30.9655 16.2734 30.9655ZM19.4704 13.2094C20.8762 13.2094 21.974 12.0727 21.974 10.6421C21.974 9.21139 20.8762 8.07471 19.4704 8.07471C18.0837 8.07471 16.9667 9.21139 16.9667 10.6421C16.9667 12.0727 18.0837 13.2094 19.4704 13.2094Z",
    fill: "white",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_18302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfocircle1);
export default __webpack_public_path__ + "static/media/info.circle 1.b2ccf7f37cbdf7536a652e11dbcc4505.svg";
export { ForwardRef as ReactComponent };